import React from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import './App.css';
import './styles/retro.css';
import InvestmentPage from './investmentPage';
import SavingsFDInterestCalculator from './savingsInterest';
import ValuesPage from './valuesPage';
import InvestmentCalculator from './investmentCalculator';

const LINKS = [
  { href: 'https://guuup.com', label: '/guuup', desc: 'Handy Nutrition Data', external: true },
  { to: '/investments', label: '/investments', desc: 'Handy Investment Cheatsheet' },
  { to: '/investments-calculator', label: '/investmentsCalculator', desc: 'Investment Calculator' },
  { to: '/savings-fd-interest-calculator', label: '/InterestCalculator', desc: 'Compare savings and FD rates across major Indian banks' },
];

const Home = () => (
  <div className="home-page">
    {/* Marquee banner */}
    <div className="home-marquee">
      {/* eslint-disable-next-line jsx-a11y/no-distracting-elements */}
      <marquee behavior="scroll" direction="left" scrollamount="3">
        ✦ WELCOME TO LONGLOOP.XYZ &nbsp;·&nbsp; BEST VIEWED AT 800×600 IN NETSCAPE NAVIGATOR 3.0 &nbsp;·&nbsp;
        THIS SITE IS ALWAYS UNDER CONSTRUCTION ✦
      </marquee>
    </div>

    <div className="home-body">
      <main className="home-main">
        <h1 className="home-title">longloop.xyz</h1>
        <p className="home-tagline">
          hi. this is my <strong>web 1.0</strong> corner of the internet.<br />
          tools i built because i was tired of bad alternatives.
        </p>

        <hr className="home-hr" />

        <p className="home-links-label">[ TOOLS ]</p>

        <div className="home-links">
          {LINKS.map((link) => (
            <div key={link.label} className="home-link-row">
              <div>
                {link.external ? (
                  <a href={link.href} className="home-link" target="_blank" rel="noopener noreferrer">
                    {link.label}
                  </a>
                ) : (
                  <Link to={link.to} className="home-link">{link.label}</Link>
                )}
                <p className="home-link-desc">{link.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <hr className="home-hr" />

        <p className="home-about">
          building things at night. no tracking. no ads. no frameworks i didn't need.
        </p>
      </main>
    </div>

    <footer className="home-footer">
      <div className="home-footer-copy">
        longloop.xyz &nbsp;·&nbsp; no cookies &nbsp;·&nbsp; no tracking
      </div>
      <div className="home-footer-compat">
        <div className="home-netscape-btn">
          <img src={`${process.env.PUBLIC_URL}/net.png`} alt="Netscape" className="home-netscape-logo" />
          <div className="home-netscape-text">
            <strong>NETSCAPE</strong>
            <em>Now!</em>
          </div>
          <span className="home-netscape-ribbon">3.0</span>
        </div>
        <span className="home-footer-compat-text">Best viewed in Netscape Navigator</span>
      </div>
    </footer>
  </div>
);

const App = () => (
  <Router>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/investments" element={<InvestmentPage />} />
      <Route path="/savings-fd-interest-calculator" element={<SavingsFDInterestCalculator />} />
      <Route path="/values" element={<ValuesPage />} />
      <Route path="/investments-calculator" element={<InvestmentCalculator />} />
    </Routes>
  </Router>
);

export default App;
